import React, { useEffect, useState } from 'react';
import { Card, CardContent, useMediaQuery, Divider, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FaUpload } from 'react-icons/fa';
// import ReferralSystem from '../components/ReferralSystem'; // Disabled - website is now free
import NotificationTest from '../components/NotificationTest';

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [premiumEmail, setPremiumEmail] = useState('');
  const [premiumUntil, setPremiumUntil] = useState('');
  const [registerStatus, setRegisterStatus] = useState('');
  const [premiumUsers, setPremiumUsers] = useState([]);
  const [loadingPremiumUsers, setLoadingPremiumUsers] = useState(false);
  const [nonPremiumUsers, setNonPremiumUsers] = useState([]);
  const [loadingNonPremiumUsers, setLoadingNonPremiumUsers] = useState(false);
  const [freeTrialUsers, setFreeTrialUsers] = useState([]);
  const [loadingFreeTrialUsers, setLoadingFreeTrialUsers] = useState(false);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');

  // State for JSON import
  const [jsonInput, setJsonInput] = useState('');
  const [jsonFileName, setJsonFileName] = useState('');
  const [jsonPreview, setJsonPreview] = useState(null);
  const [importStatus, setImportStatus] = useState('');
  const [importLoading, setImportLoading] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + '/api/user', { credentials: 'include' })
      .then(res => res.json())
      .then(data => setUser(data.user));
  }, []);

  useEffect(() => {
    if (user && !user.premium && user.role !== 'admin') {
      navigate('/register', { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    if (user && user.role === 'admin') {
      fetchPremiumUsers();
      fetchNonPremiumUsers();
      fetchFreeTrialUsers();
    }
    // eslint-disable-next-line
  }, [user]);

  const fetchPremiumUsers = async () => {
    setLoadingPremiumUsers(true);
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + '/api/admin/premium-users', { credentials: 'include' });
      const data = await res.json();
      setPremiumUsers(data.users || []);
    } catch (err) {
      setPremiumUsers([]);
    } finally {
      setLoadingPremiumUsers(false);
    }
  };

  const fetchNonPremiumUsers = async () => {
    setLoadingNonPremiumUsers(true);
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + '/api/admin/non-premium-users', { credentials: 'include' });
      const data = await res.json();
      setNonPremiumUsers(data.users || []);
    } catch (err) {
      setNonPremiumUsers([]);
    } finally {
      setLoadingNonPremiumUsers(false);
    }
  };

  const fetchFreeTrialUsers = async () => {
    setLoadingFreeTrialUsers(true);
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + '/api/admin/free-trial-users', { credentials: 'include' });
      const data = await res.json();
      setFreeTrialUsers(data.users || []);
    } catch (err) {
      setFreeTrialUsers([]);
    } finally {
      setLoadingFreeTrialUsers(false);
    }
  };



  const handleRegisterPremium = async (e) => {
    e.preventDefault();
    setRegisterStatus('');
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + '/api/admin/register-premium', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: premiumEmail, premiumUntil: premiumUntil || undefined })
      });
      const data = await res.json();
      if (res.ok) {
        setRegisterStatus(`✅ ${data.message}`);
        setPremiumEmail('');
        setPremiumUntil('');
        fetchPremiumUsers();
        fetchNonPremiumUsers();
      } else {
        setRegisterStatus(`❌ ${data.error || 'حدث خطأ'}`);
      }
    } catch (err) {
      setRegisterStatus('❌ حدث خطأ في الاتصال بالخادم');
    }
  };



  // Handle file upload
  const handleJsonFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setJsonFileName(file.name);
    const reader = new FileReader();
    reader.onload = (evt) => {
      setJsonInput(evt.target.result);
      try {
        setJsonPreview(JSON.parse(evt.target.result));
      } catch {
        setJsonPreview(null);
      }
    };
    reader.readAsText(file);
  };

  // Handle textarea paste
  const handleJsonInput = (e) => {
    setJsonInput(e.target.value);
    try {
      setJsonPreview(JSON.parse(e.target.value));
    } catch {
      setJsonPreview(null);
    }
  };

  // Import to backend
  const handleImportJson = async () => {
    setImportStatus('');
    setImportLoading(true);
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + '/api/admin/import-questions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: jsonInput,
      });
      const data = await res.json();
      if (res.ok) {
        setImportStatus('✅ تم الاستيراد بنجاح (' + (data.count || 0) + ' سؤال)');
        setJsonInput('');
        setJsonFileName('');
        setJsonPreview(null);
      } else {
        setImportStatus('❌ ' + (data.error || 'حدث خطأ أثناء الاستيراد'));
      }
    } catch (err) {
      setImportStatus('❌ حدث خطأ في الاتصال بالخادم');
    } finally {
      setImportLoading(false);
    }
  };

  const isPremiumActive = user && user.premium && user.premiumUntil && new Date(user.premiumUntil) > new Date();

  return (
    <div style={{ direction: 'rtl', padding: isMobile ? '1rem 0.5rem' : '2rem', maxWidth: 800, margin: '0 auto' }}>
      <Card sx={{ borderRadius: 3, boxShadow: 3, mb: 3 }}>
        <CardContent sx={{ p: isMobile ? 2 : 4 }}>
          <h2 style={{ color: '#1a237e', fontWeight: 'bold', fontSize: isMobile ? 22 : 28, marginBottom: 12, textAlign: 'right' }}>لوحة التحكم</h2>
          {user ? (
            <>
              <div style={{ marginBottom: 16, fontSize: isMobile ? 15 : 18, textAlign: 'right', wordBreak: 'break-word' }}>
                <b>اسم المستخدم:</b> {user.displayName || user.email}<br />
                <b>البريد الإلكتروني:</b> {user.email}<br />
                {user.role === 'admin' && <><b>نوع الحساب:</b> مدير (Administrator)<br /></>}
                <b>اشتراك:</b> {isPremiumActive ? (
                  <>
                    <span style={{ color: '#22c55e', fontWeight: 'bold' }}>مشترك (Premium)</span>
                    {user.premiumUntil && (
                      <>
                        <br />
                        <b>تاريخ انتهاء الاشتراك:</b> <span style={{ color: '#f59e42', fontWeight: 'bold' }}>{new Date(user.premiumUntil).toLocaleDateString('ar-EG')}</span>
                        <a href="/register" style={{ marginRight: 8, marginLeft: 4, background: '#1976d2', color: '#fff', borderRadius: 6, padding: isMobile ? '4px 10px' : '4px 16px', fontWeight: 'bold', textDecoration: 'none', fontSize: isMobile ? 13 : 15 }}>تمديد الاشتراك</a>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <span style={{ color: '#ef4444', fontWeight: 'bold' }}>غير مشترك</span>
                    <a href="/register" style={{ marginRight: 8, marginLeft: 4, background: '#22c55e', color: '#fff', borderRadius: 6, padding: isMobile ? '4px 10px' : '4px 16px', fontWeight: 'bold', textDecoration: 'none', fontSize: isMobile ? 13 : 15 }}>اشترك الآن</a>
                  </>
                )}
                {user.hasReceivedFreeTrial && (
                  <>
                    <br />
                    <span style={{ color: '#f59e42', fontSize: isMobile ? 13 : 14 }}>✓ حصل على الفترة التجريبية المجانية</span>
                    <br />
                    <span style={{ color: '#dc2626', fontSize: isMobile ? 12 : 13 }}>⚠️ ميزة مراجعة المقالات غير متاحة في الفترة التجريبية</span>
                  </>
                )}
              </div>
              {user.role === 'admin' && (
                <div style={{ marginTop: isMobile ? 18 : 32 }}>
                  <Divider sx={{ my: isMobile ? 2 : 4 }} />
                  {/* JSON Import Section */}
                  <h3 style={{ color: '#1976d2', fontSize: isMobile ? 17 : 22, marginBottom: 12, textAlign: 'right' }}>استيراد أسئلة من JSON</h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 18 }}>
                    <label style={{ fontWeight: 'bold', fontSize: isMobile ? 15 : 16, textAlign: 'right' }}>
                      <FaUpload style={{ marginLeft: 6 }} />رفع ملف JSON:
                      <input type="file" accept="application/json" onChange={handleJsonFile} style={{ display: 'block', marginTop: 8 }} />
                      {jsonFileName && <span style={{ marginRight: 8, color: '#1976d2', fontWeight: 'bold' }}>{jsonFileName}</span>}
                    </label>
                    <label style={{ fontWeight: 'bold', fontSize: isMobile ? 15 : 16, textAlign: 'right', display: 'block' }}>
                      أو الصق محتوى JSON هنا:
                    </label>
                    <textarea value={jsonInput} onChange={handleJsonInput} rows={6} style={{ width: '100%', borderRadius: 6, border: '1px solid #ccc', padding: 10, fontSize: 15, marginTop: 8, direction: 'ltr' }} placeholder='[{"'></textarea>
                  </div>
                  {importLoading ? (
                    <div style={{ textAlign: 'right', fontSize: isMobile ? 14 : 16 }}>جاري الاستيراد...</div>
                  ) : (
                    <button
                      onClick={handleImportJson}
                      style={{ padding: isMobile ? '0.7rem 1.2rem' : '0.7rem 1.7rem', borderRadius: 6, border: 'none', background: '#22c55e', color: '#fff', fontWeight: 'bold', fontSize: isMobile ? 15 : 16, cursor: 'pointer', width: isMobile ? '100%' : undefined }}
                    >
                      استيراد الأسئلة
                    </button>
                  )}
                  <Divider sx={{ my: isMobile ? 2 : 4 }} />
                  <h3 style={{ color: '#1976d2', fontSize: isMobile ? 17 : 22, marginBottom: 12, textAlign: 'right' }}>تسجيل مشترك جديد</h3>
                  <form onSubmit={handleRegisterPremium} style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 12, alignItems: isMobile ? 'stretch' : 'center', marginBottom: 12 }}>
                    <input
                      type="email"
                      value={premiumEmail}
                      onChange={e => setPremiumEmail(e.target.value)}
                      placeholder="البريد الإلكتروني للمستخدم"
                      required
                      style={{ padding: '0.7rem 1.2rem', borderRadius: 6, border: '1px solid #ccc', fontSize: isMobile ? 15 : 16, minWidth: isMobile ? 0 : 220, width: isMobile ? '100%' : undefined }}
                    />
                    <input
                      type="date"
                      value={premiumUntil}
                      onChange={e => setPremiumUntil(e.target.value)}
                      required
                      style={{ padding: '0.7rem 1.2rem', borderRadius: 6, border: '1px solid #ccc', fontSize: isMobile ? 15 : 16, minWidth: isMobile ? 0 : 160, width: isMobile ? '100%' : undefined }}
                    />
                    <button
                      type="submit"
                      style={{ padding: isMobile ? '0.7rem 1.2rem' : '0.7rem 1.7rem', borderRadius: 6, border: 'none', background: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: isMobile ? 15 : 16, cursor: 'pointer', width: isMobile ? '100%' : undefined }}
                    >
                      تسجيل مشترك
                    </button>
                  </form>
                  {registerStatus && <div style={{ marginBottom: 12, fontWeight: 'bold', fontSize: isMobile ? 14 : 16 }}>{registerStatus}</div>}
                  <h4 style={{ color: '#6366f1', marginTop: 24, marginBottom: 8, fontSize: isMobile ? 15 : 18, textAlign: 'right' }}>
                    قائمة المشتركين ({premiumUsers.length})
                  </h4>
                  {loadingPremiumUsers ? (
                    <div>جاري التحميل...</div>
                  ) : (
                    <Box sx={{ maxHeight: isMobile ? 180 : 260, overflowY: 'auto', background: isMobile ? '#f8fafc' : 'none', borderRadius: 2, p: isMobile ? 1 : 0 }}>
                      {premiumUsers.map(u => (
                        <Card key={u._id} sx={{ mb: 1, p: 1, background: '#f3f4f6', borderRadius: 2, boxShadow: 0 }}>
                          <div style={{ fontSize: isMobile ? 14 : 16, color: '#1976d2', fontWeight: 'bold', textAlign: 'right' }}>{u.displayName || u.email}</div>
                          <div style={{ fontSize: isMobile ? 13 : 15, color: '#555', textAlign: 'right' }}>{u.email}</div>
                          <div style={{ fontSize: isMobile ? 13 : 15, color: '#2563eb', textAlign: 'right' }}>
                            عدد الأسئلة المحلولة: {Array.isArray(u.questionStats) ? u.questionStats.length : 0}
                          </div>
                          {u.examUsage && (
                            <div style={{ fontSize: isMobile ? 12 : 14, color: '#0f766e', textAlign: 'right' }}>
                              امتحانات مجرّبة: {u.examUsage.count || 0}
                              {u.examUsage.lastLevel && ` • آخر مستوى: ${u.examUsage.lastLevel}`}
                              {u.examUsage.lastStartedAt && ` • آخر بدء: ${new Date(u.examUsage.lastStartedAt).toLocaleDateString('ar-EG')}`}
                            </div>
                          )}
                          {u.premiumUntil && (
                            <div style={{ color: '#f59e42', fontWeight: 'bold', fontSize: isMobile ? 13 : 15, textAlign: 'right' }}>
                              حتى {new Date(u.premiumUntil).toLocaleDateString('ar-EG')}
                            </div>
                          )}
                        </Card>
                      ))}
                      {premiumUsers.length === 0 && <div style={{ textAlign: 'center', fontSize: isMobile ? 14 : 16 }}>لا يوجد مشتركين بعد.</div>}
                    </Box>
                  )}

                  {importStatus && <div style={{ marginTop: 12, fontWeight: 'bold', fontSize: isMobile ? 14 : 16, color: importStatus.includes('✅') ? '#22c55e' : '#ef4444' }}>{importStatus}</div>}
                  
                  <h4 style={{ color: '#f59e42', marginTop: 24, marginBottom: 8, fontSize: isMobile ? 15 : 18, textAlign: 'right' }}>
                    قائمة المستخدمين الذين حصلوا على الفترة التجريبية ({freeTrialUsers.length})
                  </h4>
                  {loadingFreeTrialUsers ? (
                    <div>جاري التحميل...</div>
                  ) : (
                    <Box sx={{ maxHeight: isMobile ? 180 : 260, overflowY: 'auto', background: isMobile ? '#f8fafc' : 'none', borderRadius: 2, p: isMobile ? 1 : 0 }}>
                      {freeTrialUsers.map(u => (
                        <Card key={u._id} sx={{ mb: 1, p: 1, background: '#fff7ed', borderRadius: 2, boxShadow: 0 }}>
                          <div style={{ fontSize: isMobile ? 14 : 16, color: '#f59e42', fontWeight: 'bold', textAlign: 'right' }}>{u.displayName || u.email}</div>
                          <div style={{ fontSize: isMobile ? 13 : 15, color: '#555', textAlign: 'right' }}>{u.email}</div>
                          <div style={{ fontSize: isMobile ? 13 : 15, color: '#2563eb', textAlign: 'right' }}>
                            عدد الأسئلة المحلولة: {Array.isArray(u.questionStats) ? u.questionStats.length : 0}
                          </div>
                          {u.examUsage && (
                            <div style={{ fontSize: isMobile ? 12 : 14, color: '#0f766e', textAlign: 'right' }}>
                              امتحانات مجرّبة: {u.examUsage.count || 0}
                              {u.examUsage.lastLevel && ` • آخر مستوى: ${u.examUsage.lastLevel}`}
                              {u.examUsage.lastStartedAt && ` • آخر بدء: ${new Date(u.examUsage.lastStartedAt).toLocaleDateString('ar-EG')}`}
                            </div>
                          )}
                          {u.premiumUntil && (
                            <div style={{ color: '#f59e42', fontWeight: 'bold', fontSize: isMobile ? 13 : 15, textAlign: 'right' }}>
                              انتهت في {new Date(u.premiumUntil).toLocaleDateString('ar-EG')}
                            </div>
                          )}
                        </Card>
                      ))}
                      {freeTrialUsers.length === 0 && <div style={{ textAlign: 'center', fontSize: isMobile ? 14 : 16 }}>لا يوجد مستخدمين حصلوا على الفترة التجريبية بعد.</div>}
                    </Box>
                  )}
                  
                  <h4 style={{ color: '#ef4444', marginTop: 8, marginBottom: 8, fontSize: isMobile ? 15 : 18, textAlign: 'right' }}>
                    قائمة غير المشتركين ({nonPremiumUsers.length})
                  </h4>
                  {loadingNonPremiumUsers ? (
                    <div>جاري التحميل...</div>
                  ) : (
                    <Box sx={{ maxHeight: isMobile ? 180 : 260, overflowY: 'auto', background: isMobile ? '#f8fafc' : 'none', borderRadius: 2, p: isMobile ? 1 : 0 }}>
                      {nonPremiumUsers.map(u => (
                        <Card key={u._id} sx={{ mb: 1, p: 1, background: '#fffbe7', borderRadius: 2, boxShadow: 0 }}>
                          <div style={{ fontSize: isMobile ? 14 : 16, color: '#b91c1c', fontWeight: 'bold', textAlign: 'right' }}>{u.displayName || u.email}</div>
                          <div style={{ fontSize: isMobile ? 13 : 15, color: '#555', textAlign: 'right' }}>{u.email}</div>
                          <div style={{ fontSize: isMobile ? 13 : 15, color: '#2563eb', textAlign: 'right' }}>
                            عدد الأسئلة المحلولة: {Array.isArray(u.questionStats) ? u.questionStats.length : 0}
                          </div>
                          {u.examUsage && (
                            <div style={{ fontSize: isMobile ? 12 : 14, color: '#0f766e', textAlign: 'right' }}>
                              امتحانات مجرّبة: {u.examUsage.count || 0}
                              {u.examUsage.lastLevel && ` • آخر مستوى: ${u.examUsage.lastLevel}`}
                              {u.examUsage.lastStartedAt && ` • آخر بدء: ${new Date(u.examUsage.lastStartedAt).toLocaleDateString('ar-EG')}`}
                            </div>
                          )}
                          {u.premiumUntil && (
                            <div style={{ color: '#f59e42', fontWeight: 'bold', fontSize: isMobile ? 13 : 15, textAlign: 'right' }}>
                              حتى {new Date(u.premiumUntil).toLocaleDateString('ar-EG')}
                            </div>
                          )}
                        </Card>
                      ))}
                      {nonPremiumUsers.length === 0 && <div style={{ textAlign: 'center', fontSize: isMobile ? 14 : 16 }}>لا يوجد غير مشتركين بعد.</div>}
                    </Box>
                  )}
                </div>
              )}
            </>
          ) : (
            <div>جاري التحميل...</div>
          )}
        </CardContent>
      </Card>
      
      {/* Referral System - Disabled (website is now free) */}
      {/* {user && <ReferralSystem />} */}

      {/* Notification Test Component - For testing push notifications */}
      {user && <NotificationTest />}
    </div>
  );
} 